import React from 'react';
import { Link } from 'react-router-dom';
import QuoteTabsStyle from './style';
import useQuoteSectionNav from 'src/hooks/useQuoteSectionNav';
import useIsMobile from 'src/hooks/useIsMobile';

const COMPACT_TABS_BREAKPOINT = 992;

const QuoteTabs: React.FC = () => {
    const { sections, buildPath, isActive } = useQuoteSectionNav();
    const isCompact = useIsMobile(COMPACT_TABS_BREAKPOINT);

    return (
        <QuoteTabsStyle>
            <div className="container-ydp">
                <nav className="tabs" aria-label="Quote sections">
                    {sections.map((section) => (
                        <Link
                            key={section.path}
                            to={buildPath(section.path)}
                            className={`tab ${
                                isActive(section.path) ? 'active' : ''
                            }`}
                            aria-current={
                                isActive(section.path) ? 'page' : undefined
                            }
                        >
                            {isCompact ? section.shortLabel : section.tabLabel}
                        </Link>
                    ))}
                </nav>
            </div>
        </QuoteTabsStyle>
    );
};

export default QuoteTabs;
